import React from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, FileText, ArrowLeftRight, Settings, Users, Package, Tag } from 'lucide-react';
/**
 * Dev-only admin layout. Has no SEO/customer chrome.
 * The gear icon at top-right is the only link back to the customer site.
 */
export function AdminLayout() {
  const location = useLocation();
  const navItems = [{
    to: '/admin',
    label: 'Dashboard',
    icon: LayoutDashboard,
    exact: true
  }, {
    to: '/admin/orders',
    label: 'Orders',
    icon: ShoppingBag
  }, {
    to: '/admin/customers',
    label: 'Customers',
    icon: Users
  }, {
    to: '/admin/products',
    label: 'Products',
    icon: Package
  }, {
    to: '/admin/discounts',
    label: 'Discounts',
    icon: Tag
  }, {
    to: '/admin/templates',
    label: 'Templates',
    icon: FileText
  }, {
    to: '/admin/settings',
    label: 'Settings',
    icon: Settings
  }];
  return <div className="min-h-screen bg-gray-50 text-gray-900 flex flex-col" data-id="element-585">
      {/* Dev-only top bar */}
      <header className="bg-[#0b0b0b] text-white" data-id="element-586">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between" data-id="element-587">
          <div className="flex items-center gap-3" data-id="element-588">
            <div className="w-8 h-8 rounded-lg bg-yarbo-yellow flex items-center justify-center" data-id="element-589">
              <Settings className="w-4 h-4 text-yarbo-dark" data-id="element-590" />
            </div>
            <div data-id="element-591">
              <div className="text-sm font-extrabold tracking-tight" data-id="element-592">
                Merem Robotics — Admin
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-yarbo-yellow/80" data-id="element-593">
                Dev preview
              </div>
            </div>
          </div>

          {/* Single toggle back to customer site */}
          <Link to="/" className="inline-flex items-center gap-2 text-xs font-bold bg-white/10 hover:bg-white/20 transition-colors px-3 py-2 rounded-lg" title="Switch to customer site" data-id="element-594">
            <ArrowLeftRight className="w-4 h-4" data-id="element-595" />
            <span className="hidden sm:inline" data-id="element-596">Switch to Customer Site</span>
            <span className="sm:hidden" data-id="element-597">Customer</span>
          </Link>
        </div>
      </header>

      <div className="flex-1 flex flex-col lg:flex-row max-w-[1400px] w-full mx-auto" data-id="element-598">
        {/* Sidebar */}
        <aside className="lg:w-60 lg:flex-shrink-0 bg-white border-b lg:border-b-0 lg:border-r border-gray-200" data-id="element-599">
          <nav className="flex lg:flex-col p-2 lg:p-4 gap-1 overflow-x-auto" data-id="element-600">
            {navItems.map(item => {
            const isActive = item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);
            return <NavLink key={item.to} to={item.to} end={item.exact} className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-bold transition-colors flex-shrink-0 ${isActive ? 'bg-yarbo-dark text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-601">
                  <item.icon className="w-4 h-4" data-id="element-602" />
                  <span data-id="element-603">{item.label}</span>
                </NavLink>;
          })}
          </nav>
        </aside>

        {/* Outlet */}
        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-8 min-w-0" data-id="element-604">
          <Outlet data-id="element-605" />
        </main>
      </div>
    </div>;
}